import blocker from './blocker.js';

($ => {
	$('.contact-form').on('submit', function(e) {
		e.preventDefault();

		let $form = $(this);
		let $button = $form.find('button');

		blocker.block($button);

		$.post({
			url: location.pathname,
			data: $form.serialize(),
			success: () => {
				$form.siblings('.contact-form-success').show();
				$form.hide();
			},
			error: () => {

			},
			finally: () => {
				blocker.unblock($button);
			}
		})
	});
})(jQuery);